<div *ngIf="!editMode" class="editable-input">
  <div>{{ displayValue }}</div>
  <div class="icons" class="icons">
    <button type="button" class="btn-success btn-success1 btn-update" [title]="traductionsKeysEnum.MAJ| translate" (click)="toggleEditMode()"><i
      aria-hidden="true" class="fa fa-edit"></i></button>
    <img src="assets/images/time.png" class="small-image">
  </div>
</div>
<div *ngIf="editMode">
  <input type="text" (blur)="onInputBlur($event)" [(ngModel)]="updateValue"/>
  <button (click)="onConfirm($event)">{{traductionsKeysEnum.UPDATE| translate}}</button>
  <button (click)="cancelEdit()">{{traductionsKeysEnum.CANCEL| translate}}</button>
</div>
